/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Discard_Confirm_DescriptionInputs */

const en_case_discard_confirm_description = /** @type {(inputs: Case_Discard_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you've entered will be permanently removed. This cannot be undone.`)
};

const pt_br2_case_discard_confirm_description = /** @type {(inputs: Case_Discard_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo o que foi preenchido será removido permanentemente. Essa ação não pode ser desfeita.`)
};

/**
* | output |
* | --- |
* | "Everything you've entered will be permanently removed. This cannot be undone." |
*
* @param {Case_Discard_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_discard_confirm_description = /** @type {((inputs?: Case_Discard_Confirm_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Discard_Confirm_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_discard_confirm_description(inputs)
	return pt_br2_case_discard_confirm_description(inputs)
});